import { html, LitElement, nothing, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import style from './ui-rolling-number.css?inline';

const CName = 'ui-rolling-number';

@customElement(CName)
export class UiRollingNumber extends LitElement {
  static readonly styles = unsafeCSS(style);
  @property({ type: Number }) value = 0;
  @property({ type: Boolean, reflect: true, attribute: 'reduce-motion' }) reduceMotion = false;

  render() {
    const currentDigits = this._toDigits(this.value);

    return html`
      <div class="wrapper">
        ${currentDigits.map((digit, index) => {
          return html`${this._renderDigit(digit, index)}${this._renderDotIfNeeded(currentDigits.length - index)}`;
        })}
      </div>
    `;
  }

  private _renderDigit(digit: string, index: number) {
    return html`
      <span class="digit" data-value="${digit}" id="digit${index}">
        <span class="scale" aria-hidden="true">
          <span>0</span>
          <span>1</span>
          <span>2</span>
          <span>3</span>
          <span>4</span>
          <span>5</span>
          <span>6</span>
          <span>7</span>
          <span>8</span>
          <span>9</span>
        </span>
      </span>
    `;
  }

  private _renderDotIfNeeded(digitPosition: number) {
    if (digitPosition % 4 === 0) {
      return html`.`;
    }

    return nothing;
  }

  private _toDigits(num: number, size = 0): string[] {
    const result = Number.isNaN(num) ? [] : num.toString().split('');
    const padSize = Math.max(0, size - result.length);
    return [...Array(padSize).fill('\u200B'), ...result];
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UiRollingNumber;
  }
}
